import angular from 'angular';
import template from './template.html';
import './style.scss';

export class TFTSpinner {}

export const TFTSpinnerConfiguration = {
    template,
    controller: TFTSpinner,
    bindings: {
        loadingArea: '<',
        showFullScreen: '<',
    },
    controllerAs: 'spinnerCtrl',
};

angular.module('TALENYA-FE').component('tftSpinner', TFTSpinnerConfiguration);
